import { filter, flatMap, every, go, pick, mapL, flatMapL, sortBy, zipWithIndexL, some, map } from 'fxjs/es';
import { DeliveryTypeS } from '../../DeliveryType/S/Function/module/DeliveryTypeS.js';
import { calcDiscountedPrice } from '../../ProductColorPrice/S/fs.js';
import { PriceS } from '../../Price/S/Function/module/PriceS.js';
import { FundingService } from '@services/MarppleShop/features/Funding/index.ts';

export const flatAndPickUpCSs = (ups) =>
  go(
    ups,
    flatMapL((up) => up._.up_cs),
    flatMapL((up_c) => up_c._.up_c_ss),
    mapL(pick(['id', 'quantity', 'base_product_id', 'base_product_color_id', 'base_product_size_id'])),
    sortBy(({ id }) => id),
  );

export const isNotEqualUpCSs = function (up_c_ss, up_c_ss2) {
  return (
    up_c_ss.length != up_c_ss2.length ||
    !every(
      ([i, up_c_s]) =>
        up_c_s.id == up_c_ss2[i].id &&
        up_c_s.quantity == up_c_ss2[i].quantity &&
        up_c_s.base_product_id == up_c_ss2[i].base_product_id &&
        up_c_s.base_product_color_id == up_c_ss2[i].base_product_color_id &&
        up_c_s.base_product_size_id == up_c_ss2[i].base_product_size_id,
      zipWithIndexL(up_c_ss),
    )
  );
};

export const assignStoresDeliveryCompanyInUps = (ups, new_sdc) => {
  if (!new_sdc) {
    return ups;
  }

  const marpple_delivery_sdc = go(
    ups,
    flatMap((up) => {
      return up._.up_cs;
    }),
    flatMap((up_c) => {
      return up_c._.product_color._.stores_product._.original_stores_product._.stores_delivery_companies;
    }),
    filter((sdc) => {
      return DeliveryTypeS.isMarpple(sdc.delivery_type_id);
    }),
  );
  /*
   * before_sdc 에 이전 sdc 를 넣어서 스위칭할때 편하게 사용한다??
   * */
  marpple_delivery_sdc.forEach((sdc) => {
    Object.assign(sdc, new_sdc, { before_sdc: JSON.parse(JSON.stringify(sdc)) });
  });
  return ups;
};

export const includeShippingDateHiddenInSp = async (RPool, mpsRPool, ups) => {
  try {
    const fundingService = FundingService.create(RPool, mpsRPool);
    const original_stores_products = go(
      ups,
      flatMap((up) => {
        return up._.up_cs;
      }),
      flatMap((up_c) => {
        return up_c._.product_color._.stores_product._.original_stores_product;
      }),
    );
    const isFunding = await fundingService.exist({
      productIds: go(
        original_stores_products,
        map((original_stores_product) => original_stores_product.product_id),
      ),
    });

    const includeInSp = go(
      original_stores_products,
      some((original_stores_product) => original_stores_product.shipping_date_hidden),
    );

    return includeInSp || isFunding;
  } catch (_) {
    return false;
  }
};

export function baseResetPriceUpsDuplicated(product_color, quantity, now, is_marpple_price) {
  /* front에서도 쓰기 위해 baseResetPriceUps 복사 */
  return function (up_c_s) {
    const prices = calcDiscountedPrice(
      'kr',
      product_color,
      quantity,
      up_c_s.base_product_size_id,
      up_c_s.product_option_id,
      is_marpple_price,
    );

    const price_ens = calcDiscountedPrice(
      'en',
      product_color,
      quantity,
      up_c_s.base_product_size_id,
      up_c_s.product_option_id,
      is_marpple_price,
    );

    const price_jps = calcDiscountedPrice(
      'jp',
      product_color,
      quantity,
      up_c_s.base_product_size_id,
      up_c_s.product_option_id,
      is_marpple_price,
    );

    const sizes_price = _p.find(
      product_color.price_info.sizes_prices,
      (sp) => sp.id == up_c_s.base_product_size_id,
    );

    return {
      id: up_c_s.id,
      price: prices.original_one,
      price_en: price_ens.original_one,
      price_jp: price_jps.original_one,
      discounted_price: prices.discounted_one,
      discounted_price_en: price_ens.discounted_one,
      discounted_price_jp: price_jps.discounted_one,
      print_price: PriceS.add(sizes_price.print_price, sizes_price.selected_bp_options_price || 0),
      print_price_en: PriceS.add(sizes_price.print_price_en, sizes_price.selected_bp_options_price_en || 0),
      print_price_jp: PriceS.add(sizes_price.print_price_jp, sizes_price.selected_bp_options_price_jp || 0),
      bp_price: sizes_price.product_price,
      bp_price_en: sizes_price.product_price_en,
      bp_price_jp: sizes_price.product_price_jp,
      oem_price: sizes_price.oem_price || 0,
      updated_at: now,
      profit: is_marpple_price ? 0 : product_color.profit,
      profit_en: is_marpple_price ? 0 : product_color.profit_en,
      profit_jp: is_marpple_price ? 0 : product_color.profit_jp,
    };
  };
}
